import Box from "@mui/material/Box";

const offsetTop = 55,
  offestMaxHeight = offsetTop + 1;

const accordionContainer_ = (theme) => ({
  position: "fixed",
  top: offsetTop,
  left: 5,
  zIndex: 1,
  maxHeight: "calc(100vh - " + offestMaxHeight + "px)",
  overflow: "auto",
  [theme.breakpoints.down("sm")]: {
    position: "fixed",
    bottom: 0,
    top: "unset",
    left: "50%",
    transform: "translate(-50%, 0)",
  },
  scrollbarWidth: "none",
  msOverflowStyle: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
});

export default function AccordionContainer({ children }) {
  return (
    <Box role="region" aria-label="info content cards" sx={accordionContainer_}>
      {children}
    </Box>
  );
}
